import { UtilState } from "models/stateTypes/utilState";
import { UtilActionType } from "models/actionTypes/utilActionTypes";
import { ReduxConstants } from "utils/constants";
import { RootActionType } from "models/actionTypes/rootActionTypes";
import { StyleEnums } from "models/enums";

const initialState: UtilState = {
  loadingState: { isLoading: false },
  floatingMessageClass: "",
  message: { messageText: "", type: StyleEnums.DisplayType.None },
  dialogQueue: [],
  toDismissFloatingMessageKeys: [],
  leftNavCollapsed: false,
};

export const utilReducer = (state: UtilState = initialState, action: UtilActionType | RootActionType): UtilState => {
  switch (action.type) {
    case ReduxConstants.RootActions.RESET:
      return initialState;
    case ReduxConstants.UtilActions.LOADING_START:
      return { ...state, loadingState: { isLoading: true } };
    case ReduxConstants.UtilActions.LOADING_END:
      return { ...state, loadingState: { isLoading: false } };
    case ReduxConstants.UtilActions.DISPLAY_MESSAGE:
      return {
        ...state,
        message: {
          messageText: action.payload.text,
          type: action.payload.type,
          isGlobal: action.payload.isGlobal,
          showSupportLink: action.payload.showSupportLink,
        },
      };
    case ReduxConstants.UtilActions.SET_MESSAGE_CLASS:
      return {
        ...state,
        floatingMessageClass: action.payload,
      };
    case ReduxConstants.UtilActions.CLOSE_MESSAGE:
      return {
        ...state,
        message: { messageText: "", type: StyleEnums.DisplayType.None },
      };
    case ReduxConstants.UtilActions.ADD_TO_DISMISS_MESSAGE:
      return {
        ...state,
        toDismissFloatingMessageKeys: [...state.toDismissFloatingMessageKeys, action.payload],
      };
    case ReduxConstants.UtilActions.CLEAR_TO_DISMISS_MESSAGES:
      return {
        ...state,
        toDismissFloatingMessageKeys: [],
      };
    case ReduxConstants.UtilActions.DISPLAY_DIALOG:
      return {
        ...state,
        dialogQueue: [...state.dialogQueue, { ...action.payload, isOpen: true }],
        isDialogOpen: true,
      };
    case ReduxConstants.UtilActions.CLOSE_DIALOG:
      let dialogQueue;
      if (action.payload) {
        dialogQueue = state.dialogQueue.filter((dialog) => dialog.id !== action.payload);
      } else {
        dialogQueue = [...state.dialogQueue];
        dialogQueue.pop();
      }
      return {
        ...state,
        dialogQueue: dialogQueue,
        isDialogOpen: !!dialogQueue?.length,
      };
    case ReduxConstants.UtilActions.SET_LEFT_NAV_COLLAPSED:
      return {
        ...state,
        leftNavCollapsed: action.payload,
      };
    case ReduxConstants.UtilActions.SET_FULL_SCREEN_DIALOG_OPEN:
      return {
        ...state,
        isFullScreenDialogOpen: action.payload,
      };
    case ReduxConstants.UtilActions.SET_FILTER_DRAWER_OPEN:
      return {
        ...state,
        isFilterDrawerOpen: action.payload,
      };
    default:
      return state;
  }
};
